import React, { useEffect, useRef, useState } from "react";

import { IonModal, IonContent, IonButton, IonIcon } from "@ionic/react";
import { time, call } from "ionicons/icons";

import { Avatar, Spin, Row, Col, Empty, Divider, Typography } from "antd";
import { LoadingOutlined, UserOutlined } from "@ant-design/icons";

/* Global State*/ 



import moment from "moment";
import axios from "axios";

const { Paragraph } = Typography;
let globalState = undefined;

const OrderDetail = ({
  order,
  is_loading_accept_order,
  onAcceptOrder,
  is_loading_reject_order,
  onRejectOrder,
  is_loading_cancel_after_accept_order,
  onCancelAfterAcceptOrder,
  is_loading_full_order,
  onGetFullDetail,
}) => {
  
  const [is_overdue, set_is_overdue] = useState(false);
  const [is_show_consumer_info_modal, set_is_show_consumer_info_modal] = useState(false);

  const [is_loading_order, set_is_loading_order] = useState(false);
  const [full_order, set_full_order] = useState();

  const scrollRef = useRef();

  const scrollToTop = async () => {
    if (scrollRef.current && scrollRef.current.scrollToTop) {
      scrollRef.current?.scrollToTop(0, 0); // Optional animation duration
    }
  };

  const getOrderTotal = () => {
    if (order == null) {
      return 0;
    }
    let total = 0;
    for (let i of order.items) {
      total += getItemTotal(i);
    }
    return total;
  };

  const getItemTotal = (item) => {
    let singleItemPrice = item.price;
    for (let e of item?.opt || []) {
      singleItemPrice += e.price;
    }
    return singleItemPrice * item.qty;
  };

  const handleAcceptOrder = () => {
    onAcceptOrder(order.id);
  };

  const handleRejectOrder = () => {
    onRejectOrder(order.id);
  };

  const handleCancelAfterAcceptOrder = () => {
    onCancelAfterAcceptOrder(order.id);
  };

  const updateIsOverdue = () => {
    if (order?.pickupTime != null) {
      // console.log(moment(order.pickupTime).isBefore(moment()));
      set_is_overdue(moment(order.pickupTime).isBefore(moment()));
    }
  };

  function formatPhoneNumber(phoneNumber) {
    if (phoneNumber == null) {
      return null;
    }
    // Remove any non-numeric characters from the input phone number
    const numericOnly = phoneNumber.replace(/\D/g, "");

    // Check if the number has the correct length
    if (numericOnly.length !== 11) {
      return null;
    }

    // Extract the country code and the rest of the number
    const countryCode = numericOnly.slice(0, 3);
    const firstPart = numericOnly.slice(3, 7);
    const secondPart = numericOnly.slice(7);

    // Concatenate the formatted parts with spaces
    const formattedNumber = `${firstPart} ${secondPart}`;

    return formattedNumber;
  }

  /**
   * UI Component
   */
  const ItemList = () => {
    return (
      <Row style={{ width: "100%", backgroundColor: "#F4F4F4", borderRadius: 20, padding: 20 }}>
        <>{order?.items?.length > 0 ? order.items.map((item, i) => <Item key={i} item={item} />) : null}</>
        <Row justify="space-between" align="middle" style={{ padding: 10, width: "100%" }}>
          <Col style={{ fontSize: 26, fontWeight: "bold" }}>總結</Col>
          <Col style={{ fontSize: 32, fontWeight: "bold", paddingRight: 5 }}>${getOrderTotal()}</Col>
        </Row>
      </Row>
    );
  };

  const Item = ({ item }) => {
    return (
      <Row style={{ padding: 10, width: "100%" }}>
        {/* Main Food */}
        <Row wrap={false} align="top" gutter={10} style={{ width: "100%" }}>
          <Col flex="none" style={{ fontSize: 26, fontWeight: "bold", color: "#FFBB36" }}>
            x{item?.qty}
          </Col>
          <Col flex="auto" style={{ fontSize: 26, fontWeight: "bold" }}>
            <Row>{item?.name}</Row>
            {/* Opt */}
            {item?.opt?.length > 0 ? item?.opt.map((opt, optIndex) =>
              <Row key={optIndex} style={{ fontSize: 18 }}>{opt.name}</Row>
            ) : null}
            {/* Comment */}
            {item?.comment != null ? (
              <Row style={{ fontSize: 20 }}>
                <Paragraph style={{ color: "gray", margin: "0px" }} ellipsis={{ rows: 2, expandable: false }}>
                  {item?.comment}
                </Paragraph>
              </Row>
            ) : null}
          </Col>
          <Col flex="none" style={{ fontSize: 26, fontWeight: "bold" }}>
            {item?.price ? `$${getItemTotal(item)}` : "--"}
          </Col>
        </Row>

        <Divider style={{ margin: 0 }} />
      </Row>
    );
  };

  const Footer = () => {
    return order?.status == "placed" ? (
      <Row style={{ position: "sticky", bottom: 0, width: "100%" }}>
        <IonButton
          mode="ios"
          color="success"
          expand
          disabled={is_loading_accept_order || is_loading_reject_order}
          onClick={() => {
            handleAcceptOrder();
          }}
          style={{
            "--border-radius": 0,
            fontSize: 26,
            fontWeight: "bold",
            width: "100%",
          }}
        >
          {is_loading_accept_order ? (
            <Spin indicator={<LoadingOutlined style={{ fontSize: 26, color: "white" }} spin />} />
          ) : (
            "接受"
          )}
        </IonButton>
      </Row>
    ) : order?.status == "accepted" && is_overdue ? (
      <Row style={{ position: "sticky", bottom: 0, width: "100%" }}>
        <IonButton
          mode="ios"
          color="medium"
          expand
          disabled={is_loading_cancel_after_accept_order}
          onClick={() => {
            handleCancelAfterAcceptOrder();
          }}
          style={{
            "--border-radius": 0,
            fontSize: 26,
            fontWeight: "bold",
            width: "100%",
          }}
        >
          {is_loading_cancel_after_accept_order ? (
            <Spin indicator={<LoadingOutlined style={{ fontSize: 26, color: "white" }} spin />} />
          ) : (
            "沒有取餐"
          )}
        </IonButton>
      </Row>
    ) : null;
  };

  const PlacedSequence = () => {
    return (
      <Row align="middle" style={{ width: "100%", marginBottom: 10 }}>
        <Col span={12} style={{ fontSize: 36 }}>
          訂單#{order?.sequence}
        </Col>
        <Col span={12} style={{ textAlign: "right" }}>
          {order?.status == "placed" ? (
            <IonButton
              mode="ios"
              disabled={is_loading_reject_order || is_loading_accept_order}
              onClick={() => {
                handleRejectOrder();
              }}
              color="light"
              style={{ "--border-radius": 0, fontSize: 22 }}
            >
              拒絕
            </IonButton>
          ) : null}
        </Col>
      </Row>
    );
  };

  const AcceptedSequence = () => {
    return (
      <Row align="middle" style={{ width: "100%", marginBottom: 10 }}>
        <Col style={{ fontSize: 36 }}>訂單#{order?.sequence}</Col>
        <Col
          style={{
            marginLeft: 20,
            color: "#15B565",
            fontSize: 22,
            fontWeight: "bold",
            borderRadius: 20,
            padding: "10px 20px 10px 20px",
            backgroundColor: "#DDFFD4",
          }}
        >
          已接受
        </Col>
      </Row>
    );
  };
  
  const ConsumerInfo = ({ user, css }) => {
    return user?.id == null ? null : (
      <Row justify="start" align="middle" style={{ ...css,width: "100%" }}>
        <Col>
          <Avatar size={48} icon={<UserOutlined />} />
        </Col>
        <Col style={{ fontSize: 24, marginLeft: 20 }}>
          <Paragraph
            style={{
              width: "100%",
              textAlign: "start",
              margin: 0,
            }}
            ellipsis={{
              rows: 1,
            }}
          >
            顧客: <IonIcon icon={call} />
            <strong style={{ marginLeft: 10 }}>{formatPhoneNumber(user?.tel)}</strong>
          </Paragraph>

          {/* <Paragraph
            style={{
              width: "100%",
              textAlign: "start",
              margin: 0,
            }}
            ellipsis={{
              rows: 1,
            }}
          >
            與下單人不相同
          </Paragraph> */}
        </Col>
      </Row>
    );
  };

  useEffect(() => {
    console.log(order);
    scrollToTop();

    updateIsOverdue();

    const intervalId = setInterval(() => {
      updateIsOverdue();
    }, 60 * 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [order]);

  return (
    <>
      <IonContent ref={scrollRef} className="custom-scrollbar">
        {order == null ? (
          <Row justify="center" align="middle" style={{ width: "100%", height: "100%" }}>
            <Empty description="點選訂單查看詳情" style={{ fontSize: 22 }} />
          </Row>
        ) : (
          <Row style={{ fontWeight: "bold" }}>
            {/* Sequence */}
            {order?.status == "placed" ? <PlacedSequence /> : null}
            {order?.status == "accepted" ? <AcceptedSequence /> : null}
            {/* Date */}
            <Row style={{ width: "100%", marginBottom: 5 }}>
              <Col span={12} style={{ fontSize: 22 }}>
                {order?.time?.place ? moment(order.time.place).format("YYYY-MM-DD") : "--"}
              </Col>
            </Row>
            {/* Time */}
            <Row align="middle" style={{ width: "100%", marginBottom: 5 }}>
              <Col style={{ fontSize: 22 }}>
                <IonIcon icon={time} />
                {order?.time?.place ? moment(order.time.place).format("HH:mm") + "下單" : "--"}
              </Col>
              <Col style={{ marginLeft: 20, fontSize: 22 }}>
                <IonIcon icon={time} />
                {order?.pickupTime ? moment(order.pickupTime).format("HH:mm") + "提取" : "--"}
              </Col>
              {is_overdue ? (
                <Col
                  style={{
                    marginLeft: 20,
                    color: "#F29D38",
                    fontSize: 22,
                    fontWeight: "bold",
                    borderRadius: 20,
                    padding: "10px 20px 10px 20px",
                    backgroundColor: "#FBDFA8",
                  }}
                >
                  逾時
                </Col>
              ) : null}
            </Row>
            {/* Customer Info */}
            {order?.placeBy?.id == null ? (
              <Row style={{ width: "100%", marginBottom: 20 }}>
                <Col span={12} style={{ fontSize: 22 }}>
                  <IonButton
                    mode="ios"
                    disabled={
                      is_loading_reject_order ||
                      is_loading_accept_order ||
                      is_loading_cancel_after_accept_order ||
                      is_loading_full_order
                    }
                    onClick={() => {
                      onGetFullDetail(order.id);
                    }}
                    color="light"
                    style={{ "--border-radius": 0, fontSize: 22 }}
                  >
                    查看客人資料
                  </IonButton>
                </Col>
              </Row>
            ) : (
              <ConsumerInfo user={order?.ownBy} css={{marginTop: 20,marginBottom: 20}}/>
            )}

            {/* Items */}
            <ItemList />

            <Row style={{ marginTop: "10vh", visibility: "hidden" }}>.</Row>
          </Row>
        )}
      </IonContent>
      <Footer />
    </>
  );
};

export default OrderDetail;
